export default __webpack_public_path__ + "static/media/Katie-Bishop.e5b37a03.jpg";